var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('polygon',{staticClass:"line",attrs:{"fill":"currentColor","points":"16 5 19.4 11.89 27 12.99 21.5 18.35 22.8 25.92 16 22.35 9.2 25.92 10.5 18.35 5 12.99 12.6 11.89 16 5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }